require('initializers/gettext').default(__TRANSLATIONS__.gettext['pt-BR']); // eslint-disable-line no-undef
require('initializers/i18n').default('pt-BR', __TRANSLATIONS__.i18n['pt-BR']); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/pt-BR');
require('jquery-ui/ui/i18n/datepicker-pt-BR');
require('dayjs/locale/pt-br');
